/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import differenceInSeconds from 'date-fns/difference_in_seconds';
import {
  Panel,
  Table,
} from 'react-bootstrap';
import { addMinutes, subDays } from 'date-fns';
import startOfDay from 'date-fns/start_of_day';
import endOfDay from 'date-fns/end_of_day';
import addDays from 'date-fns/add_days';
import isAfter from 'date-fns/is_after';
import isBefore from 'date-fns/is_before';
import min from 'date-fns/min';
import gatewayActions from 'loraactions/gateway';
import Refresher from 'loracoms/Refresher';
import DataDirSwitch from 'loracoms/DataDirSwitch';
import DateTimePicker from 'loracoms/DateTimePicker';
import RichLabel from 'loracoms/RichLabel';
import InlineSelect from 'loracoms/InlineSelect';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ShowIf from 'loracoms/ShowIf';
import TablePager from 'loracoms/TablePager';
import PanelToolbar from 'loracoms/PanelToolbar';
import Link from 'loracoms/Link';
import { compactFormat } from 'lorautils/DateTimeUtils';
import {
  normalizeAppEUI,
  normalizeDevEUI,
} from 'lorautils/IdUtils';
import styles from './styles.scss';


function defaultFrom() {
  return subDays(new Date(), 1);
}

function defaultTo() {
  return new Date();
}

function isNew(time) {
  return differenceInSeconds(new Date(), time) < 10;
}

const propTypes = {
  intl: React.PropTypes.object.isRequired,
  getGatewayData: React.PropTypes.func.isRequired,
  gatewayId: React.PropTypes.string.isRequired,
  gatewayData: React.PropTypes.object.isRequired,
};

class CubeGtw extends React.Component {

  static handleDisableDate(d, from) {
    return isAfter(d, min(addDays(from, 7), new Date())) ||
      isBefore(d, addDays(from, -1));
  }

  constructor(props) {
    super(props);
    this.state = {
      gatewayData: props.gatewayData,
      dir: 'up',
      fields: ['radio'],
      from: defaultFrom(),
      to: defaultTo(),
    };
    this.handleToggleFields = this.handleToggleFields.bind(this);
    this.handleChangeFrom = this.handleChangeFrom.bind(this);
    this.handleChangeTo = this.handleChangeTo.bind(this);
    this.handleChangeDir = this.handleChangeDir.bind(this);
    this.handleReload = this.handleReload.bind(this);
    this.handleChangeMark = this.handleChangeMark.bind(this);
    this.intlMsg = new IntlMsg(props.intl, 'gatewaydetail.statview');
  }

  componentWillMount() {
    const { getGatewayData, gatewayId } = this.props;
    const {
      dir,
      from,
      to,
    } = this.state;
    getGatewayData(gatewayId, {
      dir,
      limit: 20,
      start: from.valueOf(),
      end: to.valueOf(),
    });
  }

  componentWillReceiveProps(nextProps) {
    const { gatewayData } = nextProps;
    if (gatewayData !== this.props.gatewayData) {
      this.setState({ gatewayData });
      if (gatewayData.status === 'success') {
        this.setState({ dataList: gatewayData.data.list });
      }
    }
  }

  handleChangeDir(dir) {
    this.setState({
      dir,
      reset: Math.random(),
    });

    const { getGatewayData, gatewayId } = this.props;
    const {
      from = defaultFrom(),
      to = defaultTo(),
    } = this.state;
    getGatewayData(gatewayId, {
      dir,
      limit: 20,
      start: from.valueOf(),
      end: this.caculaTo(to).valueOf(),
    });
  }

  handleToggleFields(fields) {
    this.setState({ fields });
  }

  handleReload() {
    this.setState({ reset: Math.random() });
    const { getGatewayData, gatewayId } = this.props;
    const { dir } = this.state;
    let { from, to } = this.state;
    // 刷新时将时间置为最新时间
    from = defaultFrom();
    to = defaultTo();
    this.setState({ from, to });
    getGatewayData(gatewayId, {
      dir,
      limit: 20,
      start: from.valueOf(),
      end: this.caculaTo(to).valueOf(),
    });
  }

  handleChangeFrom(from) {
    let { to } = this.state;
    if (from.valueOf() > to.valueOf()) {
      to = from;
    }
    this.setState({ from, to, reset: Math.random() });
    const { getGatewayData, gatewayId } = this.props;
    const { dir } = this.state;
    getGatewayData(
      gatewayId,
      {
        dir,
        limit: 20,
        start: from.valueOf(),
        end: to.valueOf(),
      });
  }

  handleChangeTo(to) {
    this.setState({ to, reset: Math.random() });
    const { getGatewayData, gatewayId } = this.props;
    const { dir, from = defaultFrom() } = this.state;
    getGatewayData(
      gatewayId,
      {
        dir,
        limit: 20,
        start: from.valueOf(),
        end: this.caculaTo(to).valueOf(),
      });
  }

  caculaTo(to) {
    return addMinutes(to, 1);
  }

  handleChangeMark(mark = '') {
    const { gatewayId, getGatewayData } = this.props;
    const {
      dir,
      from = defaultFrom(),
      to = defaultTo(),
    } = this.state;

    getGatewayData(gatewayId, {
      dir,
      limit: 20,
      start: from.valueOf(),
      end: this.caculaTo(to).valueOf(),
      mark,
    });
  }

  renderPanelToolbar() {
    const { fields, from, to } = this.state;
    const tools = [(
      <DateTimePicker
        date={from}
        closeOnSelect={false}
        onSelect={this.handleChangeFrom}
      />
    ), (
      <DateTimePicker
        date={to}
        closeOnSelect={false}
        onSelect={this.handleChangeTo}
        disabled={d => CubeGtw.handleDisableDate(d, from)}
      />
    ), (
      <DataDirSwitch onChange={this.handleChangeDir} />
    ), (
      <InlineSelect
        options={[{
          label: (
            <span>
              <i className="fa fa-wifi" />
              {this.intlMsg.msg('fields.spills.radio')}
            </span>
          ),
          value: 'radio',
          active: true,
        }, {
          label: (
            <span>
              <i className="fa fa-envelope" />
              {this.intlMsg.msg('fields.spills.datamsg')}
            </span>
          ),
          value: 'datamsg',
        }]}
        multiple
        values={fields}
        onChange={this.handleToggleFields}
      />
    )];
    return <PanelToolbar tools={tools} />;
  }

  render() {
    const { gatewayData } = this.state;
    const header = (
      <div>
        {this.intlMsg.msg('data.header')}
        <ul className="icontools">
          <li>
            <Refresher
              onReload={this.handleReload}
              reloading={gatewayData.status === 'pending'}
            />
          </li>
        </ul>
      </div>
    );

    const {
      dataList = [],
      fields = [],
      collapseAPPEUI = false,
      collapseDEVEUI = false,
      dir,
    } = this.state;
    const showRadioFields = fields.includes('radio');
    const showDataFields = fields.includes('datamsg');

    const rows = dataList.map(d => (
      <tr key={`${d.$time}-${d.deveui}-${d.fcnt}`} className={isNew(d.$time) ? styles.new : ''}>
        <td className={styles.compact}>{compactFormat(d.$time)}</td>
        <td className={styles.compact}>
          <Link to={`/application/${d.appeui}`}>
            {collapseAPPEUI ? `...${normalizeAppEUI(d.appeui).substr(-5)}` : normalizeAppEUI(d.appeui)}
          </Link>
        </td>
        <td className={styles.compact}>
          <Link to={`/application/${d.appeui}/devices/${d.deveui}`}>
            {collapseDEVEUI ? `...${normalizeDevEUI(d.deveui).substr(-5)}` : normalizeDevEUI(d.deveui)}
          </Link>
        </td>
        <td>
          <Link to={`/application/${d.appeui}/devices/${d.deveui}`}>
            {d.name}
          </Link>
        </td>
        <ShowIf if={showRadioFields && dir === 'up'}>
          <td> {d.channel} </td>
        </ShowIf>
        <ShowIf if={showRadioFields}>
          <td> {d.frequency / 1000000} </td>
        </ShowIf>
        <ShowIf if={showRadioFields}>
          <td> {`${d.bandwidth} | ${d.coderate}`} </td>
        </ShowIf>
        <ShowIf if={showRadioFields}>
          <td> {d.spreadfactor} </td>
        </ShowIf>
        <ShowIf if={showRadioFields && dir === 'up'}>
          <td>
            {d.lorasnr && Number(d.lorasnr).toFixed(1)}
          </td>
        </ShowIf>
        <ShowIf if={showRadioFields && dir === 'up'}>
          <td> {d.rssi} </td>
        </ShowIf>
        <td>
          <RichLabel
            content={d.mtype}
            translateMap={{
              UnconfirmedDataUp: this.intlMsg.msg('unconfirmeddataup'),
              UnconfirmedDataDown: this.intlMsg.msg('unconfirmeddatadown'),
              ConfirmedDataUp: this.intlMsg.msg('confirmeddataup'),
              ConfirmedDataDown: this.intlMsg.msg('confirmeddatadown'),
              JoinRequest: this.intlMsg.msg('joinrequest'),
              JoinAccept: this.intlMsg.msg('joinaccept'),
              RFU: this.intlMsg.msg('rfu'),
              Proprietary: this.intlMsg.msg('proprietary'),
            }}
          />
        </td>
        <td>{d.fcnt}</td>
        <ShowIf if={showDataFields}>
          <td> {d.fport} </td>
        </ShowIf>
        <ShowIf if={showDataFields}>
          <td> {d.fctrl} </td>
        </ShowIf>
        <ShowIf if={showDataFields}>
          <td> {d.fopts} </td>
        </ShowIf>
        <ShowIf if={showDataFields && dir === 'up'}>
          <td> {d.size} </td>
        </ShowIf>
        <ShowIf if={showDataFields}>
          <td> {d.data} </td>
        </ShowIf>
      </tr>
    ));

    const {
      gatewayData: {
        status,
        data: {
          mark,
          more,
        } = {},
      },
      reset,
    } = this.state;

    return (
      <Panel bsStyle="aisz-white" header={header}>
        {this.renderPanelToolbar()}
        <div className={styles.dataTable}>
          <Table className="aisz-table-light" striped hover bordered responsive>
            <thead>
              <tr>
                <th>{this.intlMsg.msg('data.field.time', 'lora')}</th>
                <th>
                AppEUI
                {' '}
                  <ShowIf if={collapseAPPEUI}>
                    <Link onClick={() => this.setState({ collapseAPPEUI: false })}>
                      <span className="halflings halflings-resize-full" />
                    </Link>
                  </ShowIf>
                  <ShowIf if={!collapseAPPEUI}>
                    <Link onClick={() => this.setState({ collapseAPPEUI: true })}>
                      <span className="halflings halflings-resize-small" />
                    </Link>
                  </ShowIf>
                </th>
                <th>
                DevEUI
                {' '}
                  <ShowIf if={collapseDEVEUI}>
                    <Link onClick={() => this.setState({ collapseDEVEUI: false })}>
                      <span className="halflings halflings-resize-full" />
                    </Link>
                  </ShowIf>
                  <ShowIf if={!collapseDEVEUI}>
                    <Link onClick={() => this.setState({ collapseDEVEUI: true })}>
                      <span className="halflings halflings-resize-small" />
                    </Link>
                  </ShowIf>
                </th>
                <th>
                  {this.intlMsg.msg('data.field.devname', 'lora')}
                </th>
                <ShowIf if={showRadioFields && dir === 'up'}>
                  <th>
                    <i className="fa fa-wifi" />{' '}{this.intlMsg.msg('data.field.channel', 'lora')}
                  </th>
                </ShowIf>
                <ShowIf if={showRadioFields}>
                  <th>
                    <i className="fa fa-wifi" />{' '}{this.intlMsg.msg('data.field.frequency', 'lora')}
                  </th>
                </ShowIf>
                <ShowIf if={showRadioFields}>
                  <th>
                    <i className="fa fa-wifi" />{' '}{this.intlMsg.msg('data.field.bandwidth', 'lora')}
                  </th>
                </ShowIf>
                <ShowIf if={showRadioFields}>
                  <th><i className="fa fa-wifi" />{' '}SF</th>
                </ShowIf>
                <ShowIf if={showRadioFields && dir === 'up'}>
                  <th><i className="fa fa-wifi" />{' '}SNR</th>
                </ShowIf>
                <ShowIf if={showRadioFields && dir === 'up'}>
                  <th><i className="fa fa-wifi" />{' '}RSSI</th>
                </ShowIf>
                <th> <i className="fa fa-envelope" />{' '}{this.intlMsg.msg('data.field.msgtype', 'lora')} </th>
                <th> <i className="fa fa-envelope" />{' '}{this.intlMsg.msg('data.field.frameno', 'lora')} </th>
                <ShowIf if={showDataFields}>
                  <th> <i className="fa fa-envelope" />{' '}FPort </th>
                </ShowIf>
                <ShowIf if={showDataFields}>
                  <th> <i className="fa fa-envelope" />{' '}FCtrl </th>
                </ShowIf>
                <ShowIf if={showDataFields}>
                  <th> <i className="fa fa-envelope" />{' '}FOpts </th>
                </ShowIf>
                <ShowIf if={showDataFields && dir === 'up'}>
                  <th>
                    <i className="fa fa-envelope" />{' '}{this.intlMsg.msg('data.field.size', 'lora')}
                  </th>
                </ShowIf>
                <ShowIf if={showDataFields}>
                  <th>
                    <i className="fa fa-envelope" />{' '}{this.intlMsg.msg('data.field.data', 'lora')}
                  </th>
                </ShowIf>
              </tr>
            </thead>
            <tbody>
              {rows}
            </tbody>
          </Table>
          <div className={styles.pager}>
            <TablePager
              status={status}
              mark={mark}
              more={more}
              onNext={this.handleChangeMark}
              onPrev={this.handleChangeMark}
              reset={reset}
            />
          </div>
        </div>
      </Panel>
    );
  }
}

CubeGtw.propTypes = propTypes;


const mapStateToProps = state => ({
  gatewayData: state.gateway.gatewayData,
  gateway: state.gateway.gateway.data || {},
});

const mapDispatchToProps = {
  getGatewayData: gatewayActions.gatewayData,
};

export default connect(mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CubeGtw));




// WEBPACK FOOTER //
// ./src/containers/Gateway/coms/GatewayDetail/coms/GatewayData/CubeGtw.jsx